import SSWhiteText from "@core-components/title/components/SSWhiteText";
import AppTooltip from "@core-components/tooltip/AppTooltip";
import type { AppRegion, IAppRegionInfo } from "@core-types/region.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Image, Menu } from "@mantine/core";
import { IconArrowsUpDown } from "@tabler/icons-react";

interface IRegionSelect {
  region: AppRegion;
  regions: IAppRegionInfo[];
  onRegionChange: (value: AppRegion) => void;
  availableRegion?: AppRegion[];
}

const RegionSkinProductSelect: React.FC<IRegionSelect> = ({
  region,
  regions,
  onRegionChange,
  availableRegion,
}) => {
  const { t } = useAppTranslation("common.regions");
  const { t: tRegion } = useAppTranslation("components.regionSelector");
  const regionInfo = regions.find((r) => r.code === region);

  const isDisabled = (region: IAppRegionInfo) => {
    return (
      availableRegion &&
      !availableRegion?.some(
        (ar) => ar.toLowerCase() === region.code.toLowerCase(),
      )
    );
  };

  return (
    <Menu>
      <Menu.Target>
        <Group
          className="default-icon min-w-[320px] cursor-pointer justify-between rounded-lg bg-primary-lighter px-6 py-4"
          wrap="nowrap"
        >
          <Group wrap="nowrap">
            <Image
              src={regionInfo?.whiteImage}
              alt={t(regionInfo?.code ?? "")}
              className="size-6"
            />
            <SSWhiteText className="overflow-hidden text-ellipsis text-nowrap font-secret-black">
              {t(regionInfo?.code ?? "")}
            </SSWhiteText>
            <span>{regionInfo?.codeLabel}</span>
          </Group>
          <IconArrowsUpDown />
        </Group>
      </Menu.Target>

      <Menu.Dropdown
        classNames={{
          dropdown: "bg-primary-default border-secret-blue-light p-3",
        }}
      >
        {regions.map((region) => (
          <Menu.Item
            key={region.code}
            onClick={() => onRegionChange(region.code)}
            classNames={{
              item: "my-1 py-2 rounded-md bg-transparent text-white hover:bg-primary-background",
            }}
            disabled={isDisabled(region)}
          >
            <AppTooltip
              label={isDisabled(region) ? tRegion("notAvailable") : undefined}
            >
              <Group>
                <Image
                  src={region.whiteImage}
                  alt={t(region.code)}
                  className="size-6"
                />
                <span>{t(region.code)}</span>
              </Group>
            </AppTooltip>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default RegionSkinProductSelect;
